class ctxTableTreeviewCheckboxDirective {
    constructor() {
        this.restrict = 'AE';
        this.require = '^ctxTreeview';
        this.template = '<span ctx-table-treeview-checkbox-helper="node"></span>'
    }

    static directiveFactory() {
        return new ctxTableTreeviewCheckboxDirective();
    }
}

ctxTableTreeviewCheckboxDirective.directiveFactory.$inject = [];

module.exports = ctxTableTreeviewCheckboxDirective.directiveFactory;



// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeviewCheckbox.directive.js